interface Props {
  status?: string;
  jobId?: number;
  modelName?: string;
  runningCount?: number;
  totalCount?: number;
}

export default function Statusbar({ status, jobId, modelName, runningCount = 0, totalCount = 0 }: Props) {
  const isActive = status === "running" || status === "queued";

  const label = (() => {
    if (!status) return "READY";
    if (status === "queued") return "QUEUED";
    if (status === "running") return `RENDERING ${runningCount} / ${totalCount}`;
    if (status === "done") return `COMPLETE · ${totalCount} / ${totalCount}`;
    if (status === "failed") return "FAILED";
    return "READY";
  })();

  return (
    <div className="statusbar">
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span className={"status-dot" + (isActive ? " amber" : "")} />
        <span>{label}</span>
      </div>
      {jobId && <span>job · {jobId}</span>}
      {modelName && <span>{modelName}</span>}
      <div style={{ marginLeft: "auto", display: "flex", gap: 14 }}>
        <span>AvantoAI</span>
      </div>
    </div>
  );
}
